import { render } from "./PolicyReview.vue?vue&type=template&id=7434fdfc&scoped=true"
import script from "./PolicyReview.vue?vue&type=script&lang=js"
export * from "./PolicyReview.vue?vue&type=script&lang=js"

import "./PolicyReview.vue?vue&type=style&index=0&id=7434fdfc&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7434fdfc"]])

export default __exports__